<!-- 移动端底部 Tabbar：首页 / 搜索 / 库 / 我的 -->
<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useUserStore } from "@/stores/user";
import { edition } from "@edition";

const { t } = useI18n({ useScope: "global" });
const route = useRoute();
const router = useRouter();
const user = useUserStore();

const active = computed({
  get: () => route.name as string,
  set: (name: string) => router.push({ name }),
});

// 游客 / 未登录在"我的"角标显示提示
const mineBadge = computed(() => {
  if (!user.isLoggedIn) return t("tabbar.badgeLogin");
  if (user.isGuest) return t("tabbar.badgeUpgrade");
  return "";
});
</script>

<template>
  <van-tabbar v-model="active" class="safe-bottom" route>
    <van-tabbar-item name="Home" icon="home-o" to="/home">{{ t("tabbar.home") }}</van-tabbar-item>
    <van-tabbar-item v-if="!edition.review.enabled" name="Search" icon="search" to="/search">{{ t("tabbar.search") }}</van-tabbar-item>
    <van-tabbar-item v-if="!edition.review.enabled" name="Library" icon="apps-o" to="/library">{{ t("tabbar.library") }}</van-tabbar-item>
    <van-tabbar-item v-else name="Subscription" icon="desktop-o" to="/subscription">{{ t("subscription.navTitle") }}</van-tabbar-item>
    <van-tabbar-item
      name="Mine"
      icon="user-o"
      to="/mine"
      :badge="mineBadge || undefined"
    >
      {{ t("tabbar.mine") }}
    </van-tabbar-item>
  </van-tabbar>
</template>
